import styled from 'styled-components';

const ReportMustHaveFilterList = styled.div`
  display: grid;
  grid-template-columns: 4.8rem 13.2rem 1fr;
  grid-column-gap: ${(props): string => props.theme.spaces.xl};
  grid-row-gap: ${(props): string => props.theme.spaces.xl};

  span {
    background-color: ${(props): string => props.theme.colors.offWhite};
    padding: ${(props): string =>
      `${props.theme.spaces.sm} ${props.theme.spaces.md}`};
    border-radius: ${(props): string => props.theme.borderRadius.normal};
    height: min-content;
  }
`;

export { ReportMustHaveFilterList };
